export default __webpack_public_path__ + "static/anne_raijmakers-871ee38f842000ad37712a08e7c2ac38.jpg";